// Central state for the "a newer frontend build is available" signal that the
// refresh banner subscribes to. Raised by the frontend manifest poll (see
// appVersionPoll.js) whenever it detects that the deployed bundle version has
// moved past the one baked into this tab.

let updateAvailable = false;
const subscribers = new Set();

// The version this bundle was built with (baked in by Vite at build time).
// The poll compares its remote reading against this.
export function getBundleVersion() {
  const injected = import.meta.env?.VITE_APP_VERSION;
  const value = typeof injected === 'string' ? injected.trim() : '';
  return value === '' ? 'dev' : value;
}

export function notifyUpdateAvailable() {
  if (updateAvailable) return;
  updateAvailable = true;
  subscribers.forEach((callback) => callback());
}

export function isNewVersionAvailable() {
  return updateAvailable;
}

export function subscribe(callback) {
  subscribers.add(callback);
  return () => subscribers.delete(callback);
}

// Test-only reset; not used at runtime.
export function _resetForTests() {
  updateAvailable = false;
  subscribers.clear();
}
